export default {"src":"/_next/static/media/svelte.b1b7be9c.svg","height":308,"width":256,"blurWidth":0,"blurHeight":0};